import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { NgxAuthService } from '../services/ngx-auth.service';
import { AUTH_CONFIG, NgxAuthConfig } from '../interfaces/auth-config.interface';

export const AnonUserGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(NgxAuthService);
  const router = inject(Router);
  const config = inject<NgxAuthConfig>(AUTH_CONFIG);

  return authService.state.pipe(
    take(1),
    map((user) => {
      if (!user) {
        return true;
      }

      void router.navigate([config.homeUrl]);
      return false;
    }),
  );
};

